export const LINKS = [
  {
    textId: 'nav-home',
    to: '/',
    paths: ['/', '/index'],
    isNextlink: true
  },
  {
    textId: 'nav-forum',
    to: '/categories',
    paths: ['/categories', '/category', '/topic'],
    isNextlink: true
  },
  {
    textId: 'nav-shop',
    to: 'https://fleshas.lt/shop'
  },
  {
    textId: 'nav-amxbans',
    to: 'https://fleshas.lt/amxbans'
  },
  {
    textId: 'nav-csdownload',
    to: '/csdownload',
    paths: ['/csdownload'],
    gold: true,
    isNextlink: true
  },
  {
    textId: 'nav-rules',
    to: '/category/76/taisykl%C4%97s',
    isNextlink: true
  }
];
